import type { ConceptDef } from '../types';

export const intraverbalStoryRecall: ConceptDef = {
  kind: 'tileMatch',
  id: 'intraverbal-story-recall',
  label: 'Intraverbal Story Recall',
  category: 'Intraverbal',
  description: 'Hear a one-line story and a question; tap the answer.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'Maya picked an apple. What did she pick?', answer: '🍎 apple' },
      { say: 'Sam went to the park. Where did he go?', answer: '🌳 park' },
      { say: 'The cat slept on the chair. What did the cat sleep on?', answer: '🪑 chair' },
      { say: 'Dad cooked eggs for breakfast. What did Dad cook?', answer: '🍳 eggs' },
      { say: 'The dog chased the ball. What did the dog chase?', answer: '⚽ ball' },
    ],
  },
};
